(function (window, $) {
    'use strict';

    const checkoutModules = window.TlpCheckoutModules = window.TlpCheckoutModules || {};

    checkoutModules.ajax = {
        init() {
            const $checkoutForm = $('form.checkout');
            if (!$checkoutForm.length) {
                return;
            }

            this.bindPhoneField($checkoutForm);
        },

        bindPhoneField($checkoutForm) {
            const phoneSelector = 'input[name="billing_phone"]';

            const sanitizeField = (element) => {
                const $field = $(element);
                const currentValue = String($field.val() || '');
                const sanitizedValue = this.sanitizePhoneValue(currentValue);

                if (currentValue !== sanitizedValue) {
                    $field.val(sanitizedValue);
                }
            };

            $checkoutForm
                .find(phoneSelector)
                .attr({
                    inputmode: 'tel',
                    pattern: '[0-9()+.\\-]*',
                    autocomplete: 'tel'
                })
                .each((index, element) => {
                    sanitizeField(element);
                });

            $checkoutForm
                .off('input.lpCheckoutPhone change.lpCheckoutPhone blur.lpCheckoutPhone', phoneSelector)
                .on('input.lpCheckoutPhone change.lpCheckoutPhone blur.lpCheckoutPhone', phoneSelector, (e) => {
                    sanitizeField(e.currentTarget);
                });
        },

        sanitizePhoneValue(value) {
            return String(value || '').replace(/[^0-9()+.\-]+/g, '');
        },

        getAjaxUrl() {
            if (window.ajax_object && window.ajax_object.ajax_url) {
                return window.ajax_object.ajax_url;
            }

            if (window.script_settings && window.script_settings.ajax_url) {
                return window.script_settings.ajax_url;
            }

            return '/wp-admin/admin-ajax.php';
        },

        getApplyCouponNonce() {
            if (
                window.wc_checkout_params
                && typeof window.wc_checkout_params.apply_coupon_nonce === 'string'
                && window.wc_checkout_params.apply_coupon_nonce !== ''
            ) {
                return window.wc_checkout_params.apply_coupon_nonce;
            }

            return '';
        },

        getCouponErrorMessage(response) {
            const fallbackError = 'Invalid or expired coupon.';
            const responseData = response && typeof response === 'object' ? response.data : null;

            if (typeof responseData === 'string' && responseData.trim() !== '') {
                return responseData;
            }

            if (responseData && typeof responseData.message === 'string' && responseData.message.trim() !== '') {
                return responseData.message;
            }

            return fallbackError;
        }
    };
})(window, jQuery);
